import { Card, CardBody, Col, Row } from "reactstrap";
import { AspectRatiosTitle } from "../../../Constants/Constants";
import { AspectRatiosData, AspectRatiosSubTitle } from "../../../Data/BonusUi/Ratios";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AspectRatios = () => {
  return (
    <Col xxl="12">
      <Card>
        <CommonCardHeader title={AspectRatiosTitle} span={AspectRatiosSubTitle} />
        <CardBody>
          <Row className="gy-3">
            {AspectRatiosData.map((item, index) => (
              <Col lg="3" sm="6" key={index}>
                <div className={`ratio ${item.class}`}>
                  <iframe src={item.src} title="YouTube video" allowFullScreen />
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AspectRatios;
